export class WorkspaceLoggingSettingsAws {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "cloudwatchEnabled",
            "baseName": "cloudwatchEnabled",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "cloudwatchLogGroupName",
            "baseName": "cloudwatchLogGroupName",
            "type": "string",
            "format": ""
        },
        {
            "name": "s3Enabled",
            "baseName": "s3Enabled",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "s3Uri",
            "baseName": "s3Uri",
            "type": "string",
            "format": ""
        },
        {
            "name": "opensearchEnabled",
            "baseName": "opensearchEnabled",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "opensearchEndpoint",
            "baseName": "opensearchEndpoint",
            "type": "string",
            "format": ""
        },
        {
            "name": "opensearchIndexPrefix",
            "baseName": "opensearchIndexPrefix",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return WorkspaceLoggingSettingsAws.attributeTypeMap;
    }
    constructor() {
    }
}
